var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-autocomplete',{staticClass:"py-0 mb-1",attrs:{"items":_vm.clients,"label":_vm.$t('client_selector.client'),"item-value":"id","item-text":"name","disabled":_vm.disabled},model:{value:(_vm.$store.state.clientId),callback:function ($$v) {_vm.$set(_vm.$store.state, "clientId", $$v)},expression:"$store.state.clientId"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }